/**
 * @generated SignedSource<<ffa7cfe23a1002334a1888f6287cf96c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraMultipleSelectField$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly fieldOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly name: string;
  readonly selectedOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "JiraMultipleSelectField";
};
export type JiraMultipleSelectField$key = {
  readonly " $data"?: JiraMultipleSelectField$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraMultipleSelectField">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "concreteType": "JiraOptionEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraMultipleSelectField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRequired"
        },
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    },
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "fieldOptions",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "JiraMultipleSelectField"
};
})();

(node as any).hash = "54bbee5f9eafbc5f79cae473fe8f5388";

export default node;
